(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("ant-design-vue"));
	else if(typeof define === 'function' && define.amd)
		define(["ant-design-vue"], factory);
	else if(typeof exports === 'object')
		exports["air-ui"] = factory(require("ant-design-vue"));
	else
		root["air-ui"] = factory(root["ant-design-vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__4e72__) {
return 